import { staticListProductListLineStyles as styles } from "@iewc/Overrides/Widgets/StaticList/StaticListProductListLine";
import { mediaQueriesBP } from "@iewc/Utilities/variables";
import { css } from "styled-components";

/* Verndale Custom Feature - New styles */

styles.partWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 5px;

        ${mediaQueriesBP.maxMD} {
            padding: 5px;
        }
    `,
};

styles.partStyles = {
    ...styles.partStyles,
    wrapper: {
        ...styles.partStyles?.wrapper,
        css: css`
            ${styles.partStyles?.wrapper?.css}
            align-items: center;
            flex-direction: row;
        `,
    },
    heading: {
        ...styles.partStyles?.heading,
        variant: "p",
        forwardAs: "span",
        weight: 700,
        css: css`
            ${styles.partStyles?.heading?.css}
            margin-bottom: 0;
            margin-right: 5px;
        `,
    },
    text: {
        ...styles.partStyles?.text,
        variant: "p",
        forwardAs: "span",
        css: css`
            ${styles.partStyles?.text?.css}
            width: auto;
            margin-bottom: 0;
        `,
    },
};

styles.specSheetButtonWrapper = {
    css: css`
        padding-top: 10px;

        ${mediaQueriesBP.maxMD} {
            padding: 5px;
        }
    `,
};

styles.specSheetButton = {
    variant: "secondary",
};

styles.minOrderAndMultiplesOf = {
    message: {
        variant: "legend",
        forwardAs: "span",
    },
};
